// The tab title: the app name, with "(N) " in front while N critical alerts are open (seen from another tab).

let base = typeof document !== 'undefined' ? document.title : '';
let count = 0;
let override: string | null = null;

const render = () => {
  document.title = override ?? (count > 0 ? `(${count > 99 ? '99+' : count}) ${base}` : base);
};

/** The app name (from /meta). */
export function setTitleBase(title: string) {
  base = title;
  render();
}

/** Open critical alerts; 0 removes the prefix. */
export function setTitleCount(n: number) {
  count = Math.max(0, n);
  render();
}

/** A page that needs its own title (the print page: it becomes the PDF file name); null gives it back. */
export function setTitleOverride(title: string | null) {
  override = title;
  render();
}
